var _radialGradient, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletconnectCircleBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: "0%",
    cy: "50%",
    r: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5d9df6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#a)",
    height: 512,
    rx: 256,
    width: 512
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.209772 184.531136c47.933-46.930403 125.647747-46.930403 173.580745 0l5.768814 5.648149c2.39665 2.34652 2.39665 6.150981 0 8.497502l-19.733961 19.321193c-1.198325 1.173261-3.141194 1.173261-4.339519 0l-7.938573-7.772525c-33.439258-32.739822-87.655008-32.739822-121.094267 0l-8.501555 8.323733c-1.198326 1.17326-3.141195 1.17326-4.339519 0l-19.733961-19.321193c-2.39665-2.346521-2.39665-6.150982 0-8.497502zm214.39244 39.95827 17.563263 17.195959c2.396638 2.346509 2.396652 6.150947.000031 8.497472l-79.193968 77.538711c-2.396633 2.346538-6.28237 2.346564-8.679037.000061-.00001-.00001-.000021-.000021-.000031-.000031l-56.20706-55.031481c-.599162-.58663-1.570597-.58663-2.169759 0-.000004.000004-.000007.000008-.000011.000011l-56.205863 55.03144c-2.396626 2.346544-6.282364 2.346583-8.679038.000086-.000014-.000014-.000029-.000028-.000044-.000043l-79.196171-77.539742c-2.396649-2.34652-2.396649-6.150981 0-8.497501l17.563295-17.19593c2.396649-2.34652 6.282387-2.34652 8.679037 0l56.207878 55.03225c.599163.58663 1.570596.58663 2.169759 0 .000009-.000009.000017-.000017.000026-.000024l56.205061-55.032226c2.396595-2.346574 6.282333-2.346662 8.679038-.000196.000033.000033.000066.000066.000099.000099l56.207804 55.032323c.599162.586629 1.570597.586629 2.169759 0l56.206895-55.031238c2.39665-2.346521 6.282387-2.346521 8.679037 0z",
    fill: "#fff",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletconnectCircleBlue);
export default __webpack_public_path__ + "static/media/walletconnect-circle-blue.31c29967eafbdb806bafe46f7cfe9d73.svg";
export { ForwardRef as ReactComponent };